<template>
    <div class="accordion" :class="rootClasses">
        <button type="button" class="u-reset accordion--head" @click.prevent="onRequestChange(!state.isActive)">
            <slot name="head" :is-active="state.isActive">
                <!-- fallback content -->
            </slot>
        </button>
        <div class="accordion--body" ref="body" @transitionend="finishAnimation($event)">
            <slot name="body">
                <!-- fallback content -->
            </slot>
        </div>
    </div>
</template>

<script>
    import forceReflow from 'util/dom/force-reflow';
    import bemMixin from 'vue/mixins/bem';
    import uiPatternMixin from 'vue/mixins/ui-pattern';


    const TRANSITION_END_KEY_PROP = 'max-height';


    export default {
        mixins: [
            bemMixin('accordion'),
            uiPatternMixin('isActive'),
        ],
        props: {
            isActive: {
                type: Boolean,
                default: true,
            },
        },
        data() {
            return {
                state: {
                    isAnimating: false,
                },
            };
        },
        computed: {
            rootClasses() {
                return [
                    this.bemFacet,
                    this.bemIf(this.state.isAnimating, 'is-animating'),
                    this.bemIf(this.isMounted && this.state.isActive, 'is-active'),
                ];
            },
        },
        methods: {
            // TODO: Accordion body should be lazy loaded when closed
            finishAnimation(e) {
                this.state.isAnimating = false;

                if (e && e.propertyName === TRANSITION_END_KEY_PROP) {
                    this.$emit('changed', this.state.isActive);
                }

                if (this.state.isActive && this.$refs.body) {
                    this.$refs.body.style.maxHeight = 'inherit';
                }
            },
        },
        watch: {
            'state.isActive'(newVal) {
                const { body } = this.$refs;
                this.state.isAnimating = true;

                body.style.maxHeight = `${ body.scrollHeight }px`;

                if (!newVal) {
                    forceReflow(body);
                    body.style.maxHeight = null;
                }
            },
        },
        mounted() {
            // NOTE: If it's active by default we init the component already active
            this.finishAnimation();
        },
    };
</script>



// WEBPACK FOOTER //
// index.vue?04b50fd9